<template>
  <div class="address-section">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
          <address-form :back="back" :next="nextUrl" v-on:saved="onSave"></address-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AddressForm from './AddressForm'

  export default {
    name: 'AddressPage',
    components: {
      AddressForm
    },
    props: {
      showButton: {
        type: Boolean,
        required: false,
        default: true
      },
      back: {
        type: Boolean,
        required: false,
        default: true
      },
      next: {
        type: String,
        required: false,
        default: ''
      },
      withBorder: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    computed: {
      nextUrl () {
        if (this.$route.query.next) {
          return this.$route.query.next
        }

        return this.next
      }
    },
    methods: {
      onSave (address) {
        const user = this.$store.state.user

        const payload = {
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          telNo: user.phone,
          address: {
            address: address.address,
            province: address.province,
            postcode: address.postalCode
          },
          shippingContact: {
            firstName: address.firstName,
            lastName: address.lastName,
            telNo: address.phone
          }
        }

        this.$http.post('members/profile', payload)
          .then(resp => {
            this.submitting = false
            this.$modal.hide()
            this.$store.state.toast.showToast('อัปเดตข้อมูลของคุณแล้ว', { timeLife: 1200 })
          })
          .catch(err => {
            console.log(err)
            this.submitting = false
            this.$utils.showCommonError()
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddressPage.vue?4df2355f